/**
 * Whether the Fixed Fees bulk menu may offer Lock Time / Unlock Time.
 *
 * Absent, not disabled, when any gate is closed (leanlaw-ux-principles.md #5).
 * Extracted from FixedFeesTable so the four combinations are testable without
 * mounting the whole page.
 *
 * `Charges.LockTime` is what the endpoint enforces (ERR-002); move both together.
 *
 * No BR-023 pre-check lives here: the server decides eligibility on
 * `Charge.Billed`, which the table payload lacks.
 */
export interface LockGateInput {
  /** `features` from useMeStore. */
  features?: Record<string, boolean> | null;
  /** `company.settings` from useMeStore. */
  companySettings?: Record<string, unknown> | null;
  /** `permissions` from useMeStore. */
  permissions?: Record<string, Record<string, boolean>> | null;
}

/**
 * Whether the firm opted into Time Lock at all — the gate the status column and
 * its filter use (BR-021).
 *
 * Deliberately has no permission check: reading a fee's Time Lock status is not
 * the same as changing it, so a user who cannot Lock/Unlock still sees where
 * each fee stands.
 */
export function isTimeLockVisible({
  features,
  companySettings,
}: LockGateInput): boolean {
  return (
    features?.fixedFeeTimeLock === true &&
    // Null reads Off (BR-001) — a firm that never set this behaves as today.
    companySettings?.keepTimeUnlockedAfterBilling === true
  );
}

export function canLockUnlockTime(input: LockGateInput): boolean {
  return isTimeLockVisible(input) && input.permissions?.charges?.lockTime === true;
}
